import React from 'react';
import { Button } from 'evergreen-ui';

/**
 * CustomButton component that wraps Evergreen UI Button with custom styling
 *
 * @param {Object} props - Component props
 * @param {string} props.appearance - Button appearance (primary, default, minimal)
 * @param {string} props.intent - Button intent (none, success, danger, warning)
 * @param {React.ReactNode} props.children - Button content
 * @returns {React.ReactElement} - Styled button component
 */
const CustomButton = ({ appearance, intent, className, ...props }) => {
  // Determine if we need to apply custom styling
  let customClass = className || '';

  // Add custom classes based on appearance and intent
  if (appearance === 'primary' && intent === 'danger') {
    customClass = `${customClass} custom-button-danger`;
  } else if (appearance === 'primary' && intent === 'warning') {
    customClass = `${customClass} custom-button-warning`;
  }

  return (
    <Button
      appearance={appearance}
      intent={intent}
      className={customClass}
      {...props}
    />
  );
};

export default CustomButton;
